import { useCallback } from 'react';

import { di } from 'react-magnetic-di';
import { type Route, usePathParam } from 'react-resource-router-next';

import { getStudioPath } from '../../utils/get-studio-path';
import { isStudioV2 } from '../../utils/get-studio-version';

/**
 * Transforms a studio v1 route to a studio v2 route to be used with `pushTo` / `replaceTo` if Studio V2 is enabled.
 * Intended to be a helper for generating v2 compatible paths for existing `pushTo` / `replaceTo` calls in studio v1.
 * @param route Studio v1 route
 * @returns Route with studio v2 path and studio v2 path params
 */
export const useTransformStudioRoute = () => {
	di();
	const [workspaceId] = usePathParam('workspaceId');
	const [spaceId] = usePathParam('spaceId');

	const transformRoute = useCallback(
		(route: Route) => ({
			route: {
				...route,
				path: getStudioPath(route.path),
			} as Route,
			pathParams: {
				...(isStudioV2() ? { workspaceId, spaceId } : {}),
			},
		}),
		[spaceId, workspaceId],
	);

	return { transformRoute };
};
